import { CurrencyEnum } from '@systemeio/ui'
import {
  DefaultFieldsType,
  ErrorResponseContentInterface,
  ErrorResponseInterface,
} from '@systemeio/util'
import {
  WiseRecipientApiInterface,
  WiseRecipientId,
  WiseRecipientInterface,
} from 'modules/profile/affiliate-settings/types/affiliate-settings-interface'
import {
  BankDetailsFieldsErrorsErrorResponseContentInterface,
  WiseRecipientDetailsInterface,
} from 'modules/profile/affiliate-settings/types/wise-details-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

const WISE_RECIPIENT_API = '/api/dashboard/settings/affiliate-withdrawal/wise-recipient'

export const useWiseRecipientApi = (
  setErrors?: React.Dispatch<
    React.SetStateAction<ErrorResponseContentInterface<DefaultFieldsType>>
  >,
) => {
  const { fetcher: getFetcher } = useFetch<RequestMethodsEnum.get, WiseRecipientDetailsInterface>({
    method: RequestMethodsEnum.get,
  })
  const { fetcher: currentWiseFetcher } = useFetch<
    RequestMethodsEnum.post,
    WiseRecipientDetailsInterface
  >({
    method: RequestMethodsEnum.post,
  })

  const badRequestHandler = (e: ErrorResponseInterface<DefaultFieldsType>) => {
    const bankDetailsFieldsErrors = e.errors
      .fields as unknown as BankDetailsFieldsErrorsErrorResponseContentInterface
    setErrors &&
      setErrors(prev => {
        const updatedErrorState = {
          ...prev,
        }
        if (bankDetailsFieldsErrors.accountHolderName) {
          updatedErrorState.fields['accountHolderName'] = bankDetailsFieldsErrors.accountHolderName
        }
        if (bankDetailsFieldsErrors.details) {
          Object.keys(bankDetailsFieldsErrors.details).forEach(
            key => (updatedErrorState.fields[key] = bankDetailsFieldsErrors.details[key]),
          )
        }
        return updatedErrorState
      })
  }

  const { fetcher: addWiseFetcher } = useFetch<RequestMethodsEnum.post, WiseRecipientInterface>({
    method: RequestMethodsEnum.post,
    badRequestHandler,
  })

  const { fetcher: updateWiseFetcher } = useFetch<RequestMethodsEnum.put, WiseRecipientInterface>({
    method: RequestMethodsEnum.put,
    badRequestHandler,
  })
  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  const getDefaultWiseRecipientDetails = (currency: CurrencyEnum) =>
    getFetcher(`${WISE_RECIPIENT_API}/details/${currency}`)

  const getCurrentWiseRecipientDetails = (
    currency: CurrencyEnum,
    data: WiseRecipientApiInterface,
  ) => currentWiseFetcher(`${WISE_RECIPIENT_API}/details/${currency}`, data)

  const updateWiseRecipientDetails = (id: WiseRecipientId, data: WiseRecipientApiInterface) =>
    updateWiseFetcher(`${WISE_RECIPIENT_API}/${id}`, data)

  const addWiseRecipientDetails = (data: WiseRecipientApiInterface) =>
    addWiseFetcher(`${WISE_RECIPIENT_API}`, data)

  const deleteWiseRecipientDetails = (id: WiseRecipientId) =>
    deleteFetcher(`${WISE_RECIPIENT_API}/${id}`)

  return {
    getCurrentWiseRecipientDetails,
    getDefaultWiseRecipientDetails,
    updateWiseRecipientDetails,
    addWiseRecipientDetails,
    deleteWiseRecipientDetails,
  }
}
